import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../../helpers';
import { AppContextProvider } from '../../../../../../Services/AppContext';
import { store } from '../../../../../../store/store';
import { parseRequired } from '../../../../../../Utils/form.util';
import NumberField from './NumberField';

loadDOMComponent({
	selector: 'react-number-field',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const suffix = container.getAttribute('suffix');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<NumberField
						name={name}
						placeholder={placeholder}
						value={value}
						netteRules={netteRules}
						isRequired={required}
						suffix={suffix}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
